<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-white">
    <div class="container">
      <a href="/" class="navbar-brand"> {{ appTitle }}</a>

      <button class="navbar-toggler" type="button" data-toggle="collapse"
        data-target="#navbarToggler" aria-controls="navbarToggler"
        aria-expanded="false" :aria-label="$t('toggle_navigation')"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarToggler">
        <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
          <li class="dropdown-item pl-3">
            <a href="/admin">
              <fa icon="cog" fixed-width />
              Панель управления
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';
import LocaleDropdown from './LocaleDropdown';

export default {
  data: () => ({
    appName: window.config.appName,
    fromAdmin: false
  }),
  computed: mapGetters({
    user: 'auth/user',
    appTitle: 'common/title',
  }),
  components: {
    LocaleDropdown,
  },
  methods: {
    showUniversalModal () {
      this.$store.dispatch('modals/showLogin');
    },
    closeUniversalModal () {
      this.$store.dispatch('modals/closeLogin');
    },
    async logout () {
      // Log out the user.
      await this.$store.dispatch('auth/logout');

      // Redirect to login.
      this.$router.push({ name: 'home' });
    }
  },
  beforeMount () {
    this.$store.dispatch('modals/initLogin');
  }
}
</script>

<style scoped>
.navbar {
  font-weight: 600;
  border-bottom: 1px solid #dee9f2;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

.profile-photo {
  height: 2rem;
}
</style>
